import request from '../utils/request';

//服务商列表
export function getServiceList(data) {
    return request({
        url: 'home/service/list',
        method: 'post',
        data: data,
    });
}
//新增服务商
export function saveService(data) {
    return request({
        url: 'home/service/save',
        method: 'post',
        data: data,
    });
}

//服务商详情
export function serviceInfo(data) {
    return request({
        url: 'home/service/info',
        method: 'post',
        data: data,
    });
}

//删除服务商
export function delService(data) {
    return request({
        url: 'home/service/del',
        method: 'post',
        data: data,
    });
}

// 服务商类型列表
export function serviceTypeList(data) {
    return request({
        url: 'home/servicecate/list',
        method: 'post',
        data: data,
    });
}
// 服务商审核
export function setStatus(data) {
    return request({
        url: 'home/service/up_status',
        method: 'post',
        data: data,
    });
}
// 服务商类型添加
export function servicecateSave(data) {
    return request({
        url: 'home/servicecate/save',
        method: 'post',
        data: data,
    });
}

// 服务商案例列表
export function caseList(data) {
    return request({
        url: 'home/servicecase/get_list',
        method: 'post',
        data: data,
    });
}
// 服务商案例列表
export function caseInfo(data) {
    return request({
        url: 'home/servicecase/info',
        method: 'post',
        data: data,
    });
}

// 服务商案例添加
export function caseSave(data) {
    return request({
        url: 'home/servicecase/save',
        method: 'post',
        data: data,
    });
}
// 服务商案例删除
export function delCase(data) {
    return request({
        url: 'home/servicecase/del',
        method: 'post',
        data: data,
    });
}
//场地参数更新

export function updateService(data) {
    return request({
        url: 'home/service/up_hot_sort',
        method: 'post',
        data: data,
    });
}
//删除分类
export function delType(data) {
    return request({
        url: 'home/servicecate/del',
        method: 'post',
        data: data,
    });
}


